// Who runs a team, from Edit team (DIRECTION A14, scenario B13,
// PLAN-2026-10-18-families-and-newcomers §5.4): its manager and co-managers,
// the co-manager link to send, and a co-manager off the team.
//
// A real league's only: the practice league has no co-managers.

import { TeamManagersView } from '@fsp/domain';
import { get, send, type Reply } from './api';
import { movesChanged } from './moves';

const base = (leagueId: string, teamId: string) =>
  `/leagues/${encodeURIComponent(leagueId)}/teams/${encodeURIComponent(teamId)}/managers`;

export function teamManagers(leagueId: string, teamId: string): Promise<Reply<TeamManagersView>> {
  return get(base(leagueId, teamId), TeamManagersView, { cache: 'no-store' });
}

/** A co-manager's link: a new one cancels the one before. */
export function inviteCoManager(
  leagueId: string,
  teamId: string,
): Promise<Reply<TeamManagersView>> {
  return send('POST', `${base(leagueId, teamId)}/invite`, undefined, TeamManagersView);
}

export function cancelCoManagerInvite(
  leagueId: string,
  teamId: string,
): Promise<Reply<TeamManagersView>> {
  return send('DELETE', `${base(leagueId, teamId)}/invite`, undefined, TeamManagersView);
}

/**
 * A co-manager off the team, or the reader stepping down. Every screen that
 * names the team reads it again, as after a rename (`data/team.ts`).
 */
export async function removeCoManager(
  leagueId: string,
  teamId: string,
  coManagerId: string,
): Promise<Reply<TeamManagersView>> {
  const reply = await send(
    'DELETE',
    `${base(leagueId, teamId)}/${encodeURIComponent(coManagerId)}`,
    undefined,
    TeamManagersView,
  );
  if (reply.status === 'ok') movesChanged(leagueId);
  return reply;
}

/** The link a co-manager follows: the join page, as the league's own link is. */
export const coManagerLink = (code: string): string =>
  `${window.location.origin}/join/${encodeURIComponent(code)}`;
